import _ from 'root/libs/exaforte/react/lodash';
import Components from 'root/Components';
import { Planning } from 'root/globals/Functions';
import Model from 'root/libs/exaforte/react/Model';
import CustomDate from 'root/libs/exaforte/react/CustomDate';
import { BlueprintBlockModel } from './PlannableModel';
import {
    __CONTENT_TYPE_TIME__,
} from 'root/libs/exaforte/react/ReactModel';

import moment from 'moment';

class PlanningModel extends Model {
    unplan(settings) {
        settings        = {...{cancel: false, remove_from_route: false}, ...settings};
        let recurring   = Planning.is_planning_recurring({controller: this.config.controller, field: (this.name == Components.__PLANNING_COMPONENT__ || this.name == Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__ ? 'blueprint_block_id' : 'route_id'), record_id: (this.get_field_data('component_id') == Components.__PLANNING_COMPONENT__ || this.get_field_data('component_id') == Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__ ? this.get_field_data('blueprint_block_id') : this.get_field_data('route_id')), user_id: this.get_field_data('user_id'), yearweek: new CustomDate(this.get_field_data('start_date_time')).getYearWeek()});
        
        if(_.is_empty(this.get_field_data('route_planning_id')) && recurring !== false)
        {
            let yearweek    = new CustomDate(_.get_date_format(this.get_field_data('start_date_time'), true)).getYearWeek();
            let field       = (this.name == Components.__PLANNING_COMPONENT__ || this.name == Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__ ? 'blueprint_block_id' : 'route_id');
            let data        = {start_year_week: yearweek, end_year_week: yearweek, user_id: this.get_field_data('user_id')};
            data[field]     = this.get_field_data(field);
            let model       = new Model({controller: this.config.controller, name: Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__, data: data});

            model.commit_changes({reset_start_data: false, reset_changed_data: false});
        }
        
        // Als het een vaste planning is, moeten we hem op -1 zetten, anders zal er een planning item worden aangemaakt door de server.
        if(settings.cancel)
        {
            this.set_field_data({field: 'user_id', value: -1});
            this.set_field_data({field: 'state', value: 'Geannuleerd'});
        }
        else if(!_.is_empty(this.get_field_data('relation_id'))) // Als de dienst van een hoofdaannemer komt moeten we het record wel behouden omdat die de relation_id heeft van het record bij de hoofdaannemer
        {
            this.set_field_data({field: 'user_id', value: -1});

            // Als het een structure is van een route taak en hij staat na het uitplannen niet meer in de route, dat moeten we de structure terugzetten naar een gewone dienst.
            if(this.get_field_data('structure_id') == 10667 && settings.remove_from_route)
            {
                this.set_component_name(Components.__PLANNING_COMPONENT__);
                this.set_field_data({field: 'structure_id', value: 10029});
                this.set_field_data({field: 'component_id', value: Components.__PLANNING_COMPONENT__});
            }
        }
        else
            this.remove();

        this.commit_changes({reset_start_data: false, reset_changed_data: false});
    }
}

export class TimePeriodPlanningModel extends PlanningModel {
    reset(config)
    {
        config.name = Components.__PLANNING_TIME_PERIOD_COMPONENT__;

        super.reset(config);
    }
}

export class BlueprintBlockPlanningModel extends PlanningModel {
    reset(config)
    {
        config.name = Components.__PLANNING_COMPONENT__;
        
        if(!_.is_empty(config.data.blueprint_block_id) && config.get_data_from_state != false)
        {
            let blueprint_block         = Planning.get_blueprint_block_data_for_date({controller: config.controller, blueprint_block_id: config.data.blueprint_block_id, date: config.data.date});
            let current_start_date_time = new CustomDate(config.data.date + ' ' + blueprint_block.start_time);
            let current_end_date_time   = new CustomDate(config.data.date + ' ' + blueprint_block.start_time);

            current_end_date_time.setMinutes(current_end_date_time.getMinutes() + _.time_to_minutes(blueprint_block.duration));

            config.data = {...{blueprint_block_id: blueprint_block.id, customer_contract_arrangement_id: blueprint_block.customer_contract_arrangement_id || null, customer_id: blueprint_block.customer_id, customer_object_id: blueprint_block.customer_object_id, function_group_id: blueprint_block.function_group_id, start_date_time: current_start_date_time.getDateTime(true), end_date_time: current_end_date_time.getDateTime(true), report_template_ids: blueprint_block.report_template_ids}, ...config.data || {}};
        }

        super.reset(config);
    }
}

export class RoutePlanningModel extends PlanningModel {
    reset(config)
    {
        config.name = Components.__PLANNING_ROUTE_PLANNING_COMPONENT__;
        
        if(!_.is_empty(config.data.route_id) && config.get_data_from_state != false)
        {
            let route                   = Planning.get_route_data_for_date({controller: config.controller, route_id: config.data.route_id, date: config.data.date});
            let current_start_date_time = new CustomDate(config.data.date + ' ' + route.start_time);
            let current_end_date_time   = new CustomDate(config.data.date + ' ' + route.start_time);

            current_end_date_time.setMinutes(current_end_date_time.getMinutes() + _.time_to_minutes(route.duration));

            config.data = {...{customer_id: route.customer_id, route_id: route.id, function_group_id: route.function_group_id, start_date_time: current_start_date_time.getDateTime(true), end_date_time: current_end_date_time.getDateTime(true), report_template_ids: route.report_template_ids}, ...config.data || {}};
        }

        super.reset(config);
    }
    
    after_field_change_callback(settings) {
        super.after_field_change_callback(settings);
        
        if(settings.field == 'user_id')
        {
            let route_planning_items = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__], filter_field: {route_planning_id: {value: this.get_bind_id()}}}, models: {component_classes: RoutePlanningTaskModel}});
            
            // De planning doorvoeren op de onderliggende items.
            for(let i in route_planning_items)
            {
                route_planning_items[i].set_field_data({field: settings.field, value: this.get_field_data(settings.field)});
                route_planning_items[i].commit_changes({reset_start_data: false, reset_changed_data: false});
            }
        }
    }
    
    create_route_planning_items(settings) {
        settings                    = {apply_data_to_state: true, ...settings};
        let date                    = new CustomDate(this.get_field_data('start_date_time'));
        let blueprint_blocks        = _.format_input(Planning.get_route_blueprint_blocks_for_date({controller: this.config.controller, route: {id: this.get_field_data('route_id'), date: date.getYearMonthDay()}, date: date})); // moet een format_input omdat anders de find in get_models_from_data niet werkt
        let blueprint_block_models  = this.config.controller.get_models_from_data({data: {models: [Components.__BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {id: {type: 'function', value: model => _.find(blueprint_blocks, {id: _.format_input(model.id)})}}}, models: {component_classes: BlueprintBlockModel, return_models_split_components: false}});

        for(let i in blueprint_blocks)
        {
            if(!blueprint_block_models[blueprint_blocks[i].id])
                continue;
            
            let date = _.get_date_format(blueprint_blocks[i].start_date_time, true);

            blueprint_block_models[blueprint_blocks[i].id].plan({user_id: this.get_field_data('user_id'), route_planning_id: this.get_field_data('id'), date: date, remove_current: false /* Omdat de items in de unplan van deze class al worden verwijderd, hoeven we dat hier niet opnieuw te checken */, apply_data_to_state: settings.apply_data_to_state, creator_id: this.get_field_data('creator_id')});
        }
    }
    
    unplan(settings) {
        super.unplan(settings);
        
        let route_planning_items = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__], filter_field: {route_planning_id: {value: this.get_bind_id()}, removed: {value: 't', type: 'excludes'}}}, models: {component_classes: RoutePlanningTaskModel}});
    
        // De unplan doorvoeren op de onderliggende items.
        for(let i in route_planning_items)
            route_planning_items[i].unplan(settings);
    }
}

export class RoutePlanningTaskModel extends PlanningModel {
    reset(config)
    {
        config.name = Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__;
        
        if(!_.is_empty(config.data.blueprint_block_id) && config.get_data_from_state != false)
        {
            let blueprint_block         = Planning.get_blueprint_block_data_for_date({controller: config.controller, blueprint_block_id: config.data.blueprint_block_id, date: config.data.date});
            let current_start_date_time = new CustomDate(config.data.date + ' ' + blueprint_block.start_time);
            let current_end_date_time   = new CustomDate(config.data.date + ' ' + blueprint_block.start_time);

            current_end_date_time.setMinutes(current_end_date_time.getMinutes() + _.time_to_minutes(blueprint_block.duration));

            config.data = {...{blueprint_block_id: blueprint_block.id, customer_contract_arrangement_id: blueprint_block.customer_contract_arrangement_id || null, customer_id: blueprint_block.customer_id, customer_object_id: blueprint_block.customer_object_id, function_group_id: blueprint_block.function_group_id, start_date_time: current_start_date_time.getDateTime(true), end_date_time: current_end_date_time.getDateTime(true), report_template_ids: blueprint_block.report_template_ids}, ...config.data || {}};
        }

        super.reset(config);
    }
}

export class SelfSchedulePlanningModel extends PlanningModel {
    reset(config)
    {
        config.name = Components.__SELF_SCHEDULE_PLANNING_COMPONENT__;
        let shift;
        
        if(!_.is_empty(config.data.route_id))
            shift = Planning.get_route_data_for_date({controller: config.controller, route_id: config.data.route_id, date: config.data.date});
        else
            shift = Planning.get_blueprint_block_data_for_date({controller: config.controller, blueprint_block_id: config.data.blueprint_block_id, date: config.data.date});

        let current_start_date_time = new CustomDate(config.data.date + ' ' + shift.start_time);
        let current_end_date_time   = new CustomDate(config.data.date + ' ' + shift.start_time);

        current_end_date_time.setMinutes(current_end_date_time.getMinutes() + _.time_to_minutes(shift.duration));

        config.data = {start_date_time: current_start_date_time.getDateTime(true), end_date_time: current_end_date_time.getDateTime(true), ...config.data || {}};

        super.reset(config);
    }
    
    unplan(settings) {
        settings        = {...{show_messages: true}, ...settings};
        let warnings    = [];
        
        if(this.get_field_data('joker') == 't')
            warnings.push('De medewerker heeft een joker ingezet voor deze dienst.');

        if(!_.is_empty(warnings) && settings.show_messages)
        {
            warnings.push('');
            warnings.push('Weet je zeker dat je deze medewerker evengoed wilt inplannen?');
            this.config.controller.component.setState({messageTitle: 'Let op', messageContent: warnings, messageConfirmCallback: this.unplan.bind(this), messageConfirmCallbackParams: {...settings, ...{show_messages: false}}});
        }
        else
        {
            this.remove();
            this.commit_changes({reset_start_data: false, reset_changed_data: false});
            this.save();
        }
    }
}

export class PlanningUserUnavailabilityModel extends Model {
    static range_more_then_week(settings)
    {
        return moment(settings.end_date).diff(settings.start_date, 'days') >= 7;
    }
    
    reset(config)
    {
        super.reset(config);
        
        if(!_.is_empty(this.fielddefines))
        {
            this.fielddefines = _.cloneDeep(this.fielddefines);

            this.setPeriodAmountFielddefine();
        }
    }
    
    setPeriodAmountFielddefine()
    {
        this.fielddefines.period_interval.isvisible = !_.is_empty(this.get_field_data('period_type_id')) ? 1 : 0;
    }
    
    get_field_data(field, default_value = null)
    {
        if(field == 'start_date' || field == 'end_date')
        {
            let date = super.get_field_data(field.substr(0, field.length - 5) + '_date_time');
            
            return date ? _.get_date_format(date, true) : default_value;
        }
        else if(field == 'start_time' || field == 'end_time')
        {
            let time = super.get_field_data(field.substr(0, field.length - 5) + '_date_time');
            
            return time ? _.get_time_format(time) : default_value;
        }
        
        return super.get_field_data(field, default_value);
    }
    
    set_field_data(settings)
    {
        if(settings.field == 'start_date' || settings.field == 'end_date')
        {
            const other_date = this.get_field_data(settings.field == 'start_date' ? 'end_date' : 'start_date');
            
            if(settings.field == 'start_date' && this.get_field_data('start_date') == other_date)
                this.set_field_data({ field: 'end_date', value: settings.value });
            
            if(!_.is_empty(settings.value))
            {
                if(!_.is_empty(this.get_field_data('period_type_id')) && !_.is_empty(other_date))
                {
                    if(PlanningUserUnavailabilityModel.range_more_then_week({ start_date: settings.field == 'start_date' ? settings.value : other_date, end_date: settings.field == 'end_date' ? settings.value : other_date }))
                    {
                        this.set_field_data({ field: 'period_type_id', value: null, trigger_after_field_change_update: false });
                        this.set_field_data({ field: 'period_end_date', value: null, trigger_after_field_change_update: false });
                    }
                }
                
                settings.value = settings.value + ' ' + this.get_field_data(settings.field.substr(0, settings.field.length - 5) + '_time');
            }

            settings.field = settings.field + '_time';
        }
        else if(settings.field == 'start_time' || settings.field == 'end_time')
        {
            if(!_.is_empty(settings.value))
                settings.value = this.get_field_data(settings.field.substr(0, settings.field.length - 5) + '_date') + ' ' + settings.value;

            settings.field = settings.field.substr(0, settings.field.length - 5) + '_date_time';
        }
        
        super.set_field_data(settings);
    }
    
    after_field_change_callback(settings)
    {
        if(settings.field == 'period_type_id')
            this.setPeriodAmountFielddefine();
        
        super.after_field_change_callback(settings);
    }
    
    check_values(settings) {
        settings        = { update: true, ...settings };
        let has_errors  = _.size(this.errors) > 0;
        
        super.check_values({...settings, ...{ update: false }});
        
        const start_date  = this.get_field_data('start_date');
        const end_date    = this.get_field_data('end_date');
        
        if(_.is_empty(start_date))
            this.errors['start_date'] = 'Startdatum verplicht';

        if(_.is_empty(end_date))
            this.errors['end_date'] = 'Einddatum verplicht';
        
        if(end_date < start_date)
            this.errors['end_date'] = 'Einddatum mag niet voor de startdatum vallen';
        
        if(start_date == end_date && this.get_field_data('end_time') < this.get_field_data('start_time'))
            this.errors['end_time'] = 'Eindtijd mag niet voor de starttijd vallen';
        
        if(settings.period_type_id_mandatory === true && _.is_empty(this.get_field_data('period_type_id')))
            this.errors['period_type_id'] = 'Periode verplicht';
        
        if(!_.is_empty(this.get_field_data('period_end_date')) && this.get_field_data('period_end_date') < end_date)
            this.errors['period_end_date'] = 'Periodieke einddatum mag niet voor de opgegeven datum vallen';
            
        if(!_.is_empty(this.get_field_data('period_type_id'))) {
            const type      = this.get_field_data('period_type_id');
            const startDate = moment(this.get_field_data('start_date'));
            const endDate   = moment(this.get_field_data('end_date'));
            let maxEndDate;
        
            if (type == 2)
                maxEndDate = startDate.clone().add(1, 'weeks');
            else if (type == 4)
                maxEndDate = startDate.clone().add(1, 'months');
        
            if (maxEndDate && endDate.isSameOrAfter(maxEndDate))
                this.errors['end_date'] = 'Het verschil tussen de start- en einddatum mag niet groter zijn dan de gekozen periode';
        }
        
        // Checken of er overlappende items zijn.
        if(_.is_empty(this.errors) && !_.is_empty(this.config.controller.get_data({ models: [this.config.name], filter_field: { id: { value: this.get_field_data('id'), type: 'excludes' }, user_id: { value: this.get_field_data('user_id') }, start_date_time: { value: this.get_field_data('end_date_time'), type: '<=' }, end_date_time: { value: this.get_field_data('start_date_time'), type: '>=' }, state: { value: 'Afgekeurd', type: 'excludes' } } })))
            this.errors['start_date'] = 'Er zit in de opgegeven periode al een niet beschikbaarheid';

        if(settings.update && (has_errors || this.has_errors()))
		    this.update();
    }
}

export class PlanningExceededRegistrationModel extends Model {
    constructor(config) {
        super(config);

        this.fielddefines = _.cloneDeep(this.fielddefines);
    }

    reset(config)
    {
        config      = {exceeded: true, ...config};
        config.name = Components.__PLANNING_EXCEEDED_REGISTRATION_COMPONENT__;
        
        super.reset(config);
    }
    
    set_field_data(settings) {
        if(settings.field == 'start_date_time' || settings.field == 'end_date_time')
        {
            if(settings.make_mandatory && !_.is_empty(this.fielddefines))
            {
                let type                                                    = settings.field.split('_')[0];
                this.fielddefines[settings.field].mandatory                 = 't';
                this.fielddefines['old_' + type + '_date_time'].mandatory   = 't';
                this.fielddefines[type + '_time_reason'].mandatory          = 't';
            }
        }
        
        super.set_field_data(settings);
    }
    
    check_values(settings) {
        settings        = { update: true, ...settings };
        let has_errors  = _.size(this.errors) > 0;
        
        super.check_values({...settings, ...{ update: false }});
        
        if(!_.is_empty(this.get_field_data('start_date_time')) && _.is_empty(this.get_field_data('start_time_reason')))
            this.errors['start_time_reason'] = 'Starttijd reden is verplicht';
        
        if(!_.is_empty(this.get_field_data('end_date_time')) && _.is_empty(this.get_field_data('end_time_reason')))
            this.errors['end_time_reason'] = 'Eindtijd reden is verplicht';

        if(settings.update && (has_errors || this.has_errors()))
		    this.update();
    }
}